import { useCourseOptions} from "../../hooks/dropdownOptions";

export const useFormConfig = () => {
  const courseOptions = useCourseOptions();
  return {
    moduleForm: {
      formTitle: "Module",
      initialFormData: {
        title: "",
        courseId: null,
        description: null,
      },
      fieldConfig: [ 
        {
          key: "title",
          label: "Module Title",
          type: "text",
          placeholder: "Enter Module Title",
          required: true,
          alphaOnly: true 
        },
        {
          key: "courseId",
          label: "Course",
          type: "dropdown",
          options: courseOptions,
          placeholder: "Select a Course",
          required: true,
        },
        {
          key: "description",
          label: "Description",
          type: "text",
          placeholder: "Enter Description",
          required: true,
          alphaOnly: true 
        },
      ],
    },
  };
};
